<template>
  <v-autocomplete @input="event => { emitChange(event) }" v-model="selectedAffiliation" :items="affiliations"
    :label="labelText" clearable dense outlined hide-details></v-autocomplete>
</template>

<script>
import AcademyService from "@/services/AcademyService";

export default {
  data() {
    return {
      selectedAffiliation: null,
      affiliations: null,
      labelText: null
    }
  },
  created() {
    if (this.label)
      this.labelText = this.label;
    AcademyService.affiliations()
      .then(data => {
        if (data) {
          this.affiliations = data.sort();
        }
      });
  },
  props: {
    value: null,
    label: null
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        this.selectedAffiliation = newValue
      }
    }
  },
  methods: {
    emitChange(event) {
      this.$emit('input', event)
    }
  }
};
</script>

<style scoped></style>
